export const LIVE_NFO = "LIVE_NFO";
export const LIVE_NFO_ADD_MSG = "LIVE_NFO_ADD_MSG";
export const LIVE_NFO_CLEAR_MSG = "LIVE_NFO_CLEAR_MSG";
export const LIVE_NFO_ERROR = "LIVE_NFO_ERROR";
export const LIVE_NFO_HIDE_ERROR = "LIVE_NFO_HIDE_ERROR";
export const LIVE_NFO_START_LOADER = "LIVE_NFO_START_LOADER";
export const LIVE_NFO_STOP_LOADER = "LIVE_NFO_STOP_LOADER";
